import React from "react";
import { Input } from "../../FormInputs/Input/Input";
import cn from "classnames";
import s from "../styles/PortfolioSettings.module.scss";
import { PortfolioDTOWithDetailsV3 } from "../../../../../generated-api-v3";
import Button from "../../Button/Button";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { ThemeSwitcher } from "../../ThemeSwitcher/ThemeSwitcher";

interface IOwnProps {
  portfolioInfo?: PortfolioDTOWithDetailsV3;
  loading?: boolean;
  saveName(nextName: string): Promise<any>;
}

export const PortfolioSettingsDetails = ({
  portfolioInfo,
  saveName,
}: IOwnProps) => {
  const { user } = useAuthenticator(({ user }) => [user]);
  const email = user?.attributes?.email;
  const familyName = user?.attributes?.family_name;
  const name = user?.attributes?.name;
  const fullName = `${name ?? ""} ${familyName ?? ""}`.trim();

  const [portfolioName, setPortfolioName] = React.useState(portfolioInfo?.name);
  const [dirty, setDirty] = React.useState(false);
  const [working, setWorking] = React.useState(false);
  React.useEffect(() => {
    if (portfolioInfo?.name) {
      setPortfolioName(portfolioInfo?.name);
    }
  }, [portfolioInfo?.name]);

  const showSaveNameButton =
    dirty && !!portfolioName && portfolioName !== portfolioInfo?.name;

  const handleSaveName = () => {
    setWorking(true);
    saveName(portfolioName!)
      .then((result) => {
        setDirty(false);
      })
      .catch((error) => {
        alert(error.message);
      })
      .finally(() => {
        window.location.reload();
        setWorking(false);
      });
  };

  return (
    <div>
      {/* Profile Section */}
      <div style={{ marginBottom: "24px" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "4px",
              flex: 1,
            }}
          >
            {fullName && (
              <div
                style={{
                  fontSize: "16px",
                  fontWeight: 600,
                  lineHeight: 1.4,
                  wordBreak: "break-word",
                }}
              >
                {fullName}
              </div>
            )}
            {email && (
              <div
                style={{
                  fontSize: "13px",
                  fontWeight: 400,
                  opacity: 0.7,
                  lineHeight: 1.4,
                  wordBreak: "break-word",
                }}
              >
                {email}
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Workgroup Name */}
      <div style={{ marginBottom: "16px" }}>
        <label
          style={{ display: "block", marginBottom: "8px", fontWeight: 600 }}
        >
          Workgroup Name
        </label>
        <div style={{ padding: "8px 0", fontSize: "14px" }}>
          {portfolioInfo?.workgroup || "-"}
        </div>
      </div>

      {/* Portfolio Currency */}
      <div style={{ marginBottom: "16px" }}>
        <label
          style={{ display: "block", marginBottom: "8px", fontWeight: 600 }}
        >
          Portfolio Currency
        </label>
        <div style={{ padding: "8px 0", fontSize: "14px" }}>
          {portfolioInfo?.currencyCode || "-"}
        </div>
      </div>

      {/* Portfolio Name - Editable */}
      <label style={{ fontWeight: 600 }}>Portfolio Name</label>
      <Input
        name={""}
        value={portfolioName}
        onChange={(event) => {
          setDirty(true);
          setPortfolioName(String(event.target.value));
        }}
      />
      {showSaveNameButton && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            margin: "0.5rem",
          }}
        >
          <Button
            style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-inverse)",
            }}
            disabled={working}
            onClick={handleSaveName}
          >
            Save portfolio name
          </Button>
        </div>
      )}
      <div className={cn(s.nameErrors)}></div>
    </div>
  );
};
